import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { Camera, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const avatarSrc = (url) => (url ? (url.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url) : null);

export const Avatar = ({ src, name, size = 64, className = '' }) => {
  const initials = (name || '·').split(' ').map((n) => n[0]).slice(0, 2).join('');
  const s = avatarSrc(src);
  return (
    <div className={`rounded-full bg-amber-500/10 border border-amber-500/40 flex items-center justify-center text-amber-500 font-bold overflow-hidden shrink-0 ${className}`} style={{ width: size, height: size, fontSize: size / 2.8, fontFamily: 'Outfit, sans-serif' }} data-testid="avatar">
      {s ? <img src={s} alt={name} className="w-full h-full object-cover" /> : initials}
    </div>
  );
};

export const AvatarUploader = ({ src, name, onUploaded }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error('Máximo 5 MB'); return; }
    setBusy(true);
    try {
      const fd = new FormData(); fd.append('file', file);
      const res = await fetch(`${API}/uploads/avatar`, { method: 'POST', credentials: 'include', body: fd });
      if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.detail || 'Error'); }
      const data = await res.json();
      toast.success('Foto de perfil actualizada');
      onUploaded?.(data.avatar_url);
    } catch (err) { toast.error(err.message || 'No se pudo subir la foto'); } finally { setBusy(false); e.target.value = ''; }
  };
  return (
    <div className="relative shrink-0" data-testid="avatar-uploader">
      <Avatar src={src} name={name} size={72} />
      <button type="button" data-testid="avatar-upload-btn" onClick={() => ref.current?.click()} disabled={busy} className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-amber-500 hover:bg-amber-600 text-slate-950 flex items-center justify-center border-2 border-[#121418] transition-colors" title="Cambiar foto">
        {busy ? <Loader2 size={13} className="animate-spin" /> : <Camera size={13} />}
      </button>
      <input ref={ref} data-testid="avatar-file-input" type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="hidden" onChange={pick} />
    </div>
  );
};
